import styled, {css} from 'styled-components'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'

export const StyledUserRow = styled(Grid)(
    ({theme: {spacing}}) => css`
        grid-template-columns: 1fr auto;
        padding: ${spacing}px ${spacing * 2}px;
        align-items: center;
        margin-bottom: ${spacing}px;
    `
)
